import { createSelector } from 'reselect';

import getOrderNotReadyReasons from './getOrderNotReadyReasons';

export default createSelector([getOrderNotReadyReasons], (reasons): boolean => {
  return reasons.length === 0;
});
